import permissions from "./permissions";

function loopPermission(permissions,selectedPermission=[],includeParent=false,permissionsListed=[],parentList=[],parent=null) {
    for(let permission of permissions){

        if(selectedPermission.includes(permission.value)){
            permissionsListed.push(permission.value)
            if(includeParent && parent && parentList.indexOf(parent.value)<0) parentList.push(parent.value)

        }

        if(includeParent && parent && permissionsListed.includes(parent.value))  permissionsListed.push(permission.value)

        if('children' in permission){
            permissionsListed = loopPermission(permission.children,selectedPermission,includeParent,permissionsListed,parentList,permission)['listed']
        }


    }
    return {listed:permissionsListed,parent:parentList}

}

export default function permissionsFilter(permissionsList,depth=4) {
    // let allPermissions = []
    // console.log(permissionsList,'initial-list')
    // allPermissions = loopPermission(permissions,permissionsList,true)
    // console.log(allPermissions,'initial-list','semi-list')
    // for(let i=0;i<depth-1;i++) allPermissions = loopPermission(permissions,allPermissions)
    // console.log(allPermissions,'initial-list','final-list')
    let allPermissions = []
    allPermissions = loopPermission(permissions,permissionsList,true)
    let permissionsS = allPermissions.listed
    allPermissions.parent.forEach(item=>permissionsS.push(item))
    for(let i=0;i<depth-1;i++) allPermissions = loopPermission(permissions,allPermissions.listed)
    return permissionsS;
}

